import React from 'react'
import { colors } from 'helpers/colors'

function SvgCheckSolid({ size = 30, color = colors.gray[700] }) {
  return (
    <svg width={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3 8L6.5 11.5L13 5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default SvgCheckSolid
